/**
 * The client half of the free-text guard (fields handoff §F). The server
 * runs the same patterns on the sidecar (server/src/catalog/phi.ts) and
 * answers 422; this lets the uploader say so before the Import click.
 * Deliberately over-eager: a false positive costs a rephrase.
 */
const PATTERNS: Array<[RegExp, string]> = [
  [/\b\d{6,}\b/g, 'a number that looks like a record number'],
  [/\b[A-Z]{1,3}[-_ ]?\d{2}[-_]\d{3,}\b/g, 'an accession-shaped code'],
  [/\b\d{4}-\d{2}-\d{2}\b/g, 'a date'],
  [/\b\d{1,2}\/\d{1,2}\/\d{2,4}\b/g, 'a date'],
  [/\b(?:jan|feb|mar|apr|may|jun|jul|aug|sep|sept|oct|nov|dec)[a-z]*\.?\s+\d{1,2}(?:st|nd|rd|th)?,?\s+\d{4}\b/gi, 'a date'],
  [/\b\d{1,2}\s+(?:jan|feb|mar|apr|may|jun|jul|aug|sep|sept|oct|nov|dec)[a-z]*\.?\s+\d{4}\b/gi, 'a date'],
  [/\b(?:mrn|nhs|ssn|dob)\b[:#\s]*[\w-]+/gi, 'a record identifier'],
];

export function findIdentifierLikeText(text: string | null | undefined): Array<{ fragment: string; why: string }> {
  if (!text) return [];
  const hits: Array<{ fragment: string; why: string }> = [];
  for (const [re, why] of PATTERNS) for (const m of text.matchAll(re)) hits.push({ fragment: m[0], why });
  return hits;
}
